module.exports = __webpack_public_path__ + "img/et_get.8e73f6e.png";